/**
 * Copyright (c) 2022 by 安徽网才信息技术股份有限公司
 *
 * 除非事先获得版权所有人的许可, 禁止以下几项行为:
 * 1. 对该软件的任何源代码和技术文档进行任意形式的打包、分发或复制用于其他目的。
 * 2. 向第三方透露任何与该软件相关的源代码或技术文档。
 * 3. 更改或删除软件或源码中的版权声明。
 */

export default {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: '人事考试网',
    /**
     * @description token在Cookie中存储的天数，默认1天
     */
    cookieExpires: 1,
    /**
     * @description 是否使用国际化，默认为false
     *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
     *              用来在菜单中显示文字
     */
    useI18n: true,
    /**
     * @description api请求基础路径
     */
    apiBaseUrl: process.env.VUE_APP_API_BASE_URL,
    /**
     * @description 默认打开的首页的路由name值，默认为home
     */
    homeName: 'home',
    wcAgents: ['www', 'xinanpta', 'ahwc'],
    /**
     * @description 安徽烟草
     */
    ycAgents: ['ahyc'],
    /**
     * @description 安徽省生态环境产业集团
     */
    stAgents: ['sthjjt'],
    /**
     * @description 庐阳学前教育
     */
    jyProjectId: ['70', '103'],
    /**
     * @description 需要加载的插件
     */
    colorList: [
        '#FF824D',
        '#FACE3C',
        '#98D000',
        '#FF824D',
        '#776BFF',
        '#04DBDB',
        '#1BD115',
        '#F5BA18',
        '#1E76FA',
        '#FA46B5',
        '#31C7F5'
    ],
    plugin: {
        'error-store': {
            showInHeader: true, // 设为false后不会在顶部显示错误日志徽标
            developmentOff: true // 设为true后在开发环境不会收集错误信息，方便开发中排查错误
        }
    }
};
